namespace GeniuzPOS.AdvPromo {
    export class Adv05ItemDtColumns {
        static columnsKey = 'AdvPromo.Adv05ItemDt';
    }
}
